let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ituVa")).then(() => parcelRequire('6RGeE'));